import axios from "axios";

export const getLaporanNeraca = async () => {
  return await axios.post(
    `${window._HOST}admin/laporanJurnal/neraca`,
    {},
    {
      withCredentials: true,
    }
  );
};
